import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'IT Cluster | Міжнародний IT Кластер — Угорщина та ЄС';
const metaDesc = document.createElement('meta');
metaDesc.name = 'description';
metaDesc.content = "Міжнародний комерційно-освітній IT кластер. Об'єднуємо технологічні компанії, стартапи та освітні інституції для спільного зростання на європейському ринку.";
document.head.appendChild(metaDesc);
document.documentElement.lang = 'uk';
render(<App data-id="element-353" />, document.getElementById('root'));